import { Portal } from 'react-portal';

export default Portal;
